<app-admin-header
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
></app-admin-header>
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
<!-- skelition   -->

<app-skelitions
  [hidden]="!skelition"
  [value]="10"
  class="mb-2"
></app-skelitions>

<!-- *ngIf="filteredData.length > 0 || (!!selectionData && selectionData.length > 0)" -->

<div class="container-fluid bg-img-v4 py-5 px-5" [hidden]="skelition">
  <div class="row d-flex align-items-baseline m-0 v4-bg-view">
    <div class="col-12 mb-3">
      <input
      filterButton
        type="text"
        class="radius-8 mt-2"
        style="width: 100%"
        pInputText
        placeholder="{{ 'Discus' | translator }}"
        (input)="onSearchChange($event)"
        [(ngModel)]="searchText"
      />
    </div>
    <!-- filters -->
    <div class="col-md-6 col-sm-12 col-12">
      <p-dropdown
      filterButton
        [options]="ouTypes"
        [(ngModel)]="typeFilter"
        (onChange)="filterFunctionByPostTypeFilter($event); typeFilter = $event.value"
        placeholder="{{ 'Select the type' | translator }}"
        [filter]="true"
        styleClass=" sstarabic w-100"
      >
        <ng-template let-item pTemplate="item">
          <i [ngClass]="item.icon"></i>
          {{ item.label }}
        </ng-template>
      </p-dropdown>
    </div>

    <div class="col-md-6 col-sm-12 col-12">
      <p-treeSelect
        appendTo="body"
        id="ouSELECTIONId"
        filterButton
        class="w-md-20rem w-100"
        containerStyleClass="w-100"
        [(ngModel)]="oufilter"
        (onNodeSelect)="filterFunctionByPostOuFilter($event)"
        [options]="selectedTreeData  || []"
        placeholder="{{ 'Classification of entity services' | translator }}"
        [filter]="true"
        [filterInputAutoFocus]="true"
      >
        <ng-template let-node pTemplate="default">
          <div class="d-flex">
            <img
              *ngIf="checkisImg(node.data); else elseBlock"
              src="{{ staticURL }}{{ node.data }}"
              class="img-fluid p-1"
              style="
                height: 30px;
                width: 30px;
                background: white;
                border-radius: 6px;
                margin-left: 5px;
              "
            />
            <ng-template #elseBlock>
              <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
            </ng-template>
            <b class="text-nowrap">{{ node.label }}</b>
          </div>
        </ng-template>
      </p-treeSelect>
    </div>

    <div class="col-md-12 col-sm-12 col-12">
      <div class="custom-flex-between-column">
        <div class="d-flex wrapp">
          <button
            pButton
            pRipple
            label="{{ 'Reset' | translator }}"
            icon="pi pi-refresh"
            (click)="refresh()"
            class="p-button-help my-2 mx-1 btn-shadow"
          ></button>
          <button
            *ngIf="hasUDPermission()"
            pButton
            pRipple
            label="{{ 'Change classification' | translator }}"
            (click)="updateOUModal = true"
            icon="pi pi-plus"
            [disabled]="!selectionData || !selectionData.length"
            class="p-button-help my-2 mx-1 btn-shadow"
          ></button>
          <button
            *ngIf="hasUDPermission()"
            pButton
            pRipple
            label="{{ 'amendment' | translator }}"
            (click)="updateData()"
            icon="pi pi-pencil my-2 mx-1"
            [disabled]="!selectionData || !selectionData.length"
            class="p-button-help my-2 mx-1 btn-shadow"
          ></button>
          <button
            *ngIf="hasUDPermission()"
            pButton
            pRipple
            label="{{ 'Delete' | translator }}"
            (click)="reasonHolder = undefined; reasonModal = true"
            icon="pi pi-trash"
            [disabled]="!selectionData || !selectionData.length"
            class="p-button-help my-2 mx-1 btn-shadow"
          ></button>

          <button
            pButton
            pRipple
            *ngIf="activationFilter && hasPermission('SIGN_SERVICE', 'a')"
            (click)="confirmInactiveService(true)"
            icon="pi pi-exclamation-circle mx-1"
            class="p-button-help my-2 mx-1 btn-shadow"
            [disabled]="!selectionData || !selectionData.length"
          >
            {{ "Deactivate Data" | translator }}
          </button>

          <button 
            pButton
            pRipple
            class="p-button-help my-2 mx-2 btn-shadow excel-button" 
            (click)="exportExcel()"
            icon="fa-regular fa-file-excel mx-2">
            <p-progressSpinner
              class="v4-spin"
              *ngIf="downloadExcel"
              ariaLabel="loading"
            ></p-progressSpinner>
          </button>


          <button
            pButton
            pRipple
            *ngIf="!activationFilter && hasPermission('SIGN_SERVICE', 'a')"
            (click)="confirmInactiveService(false)"
            icon="pi pi-check-circle mx-1"
            class="p-button-help my-2 mx-1 btn-shadow"
            [disabled]="!selectionData || !selectionData.length"
          >
            {{ "Activate Data" | translator }}
          </button>

          <span class="multi-btn-box">
            <button
            *ngIf="hasPermission('SIGN_SERVICE', 'a')"
            (click)="confirmSignService()"
            icon="pi pi-verified"
            class="multi-btn btn-border-right btn-shadow"
            [disabled]="!selectionData || !selectionData.length"
            >
            <i class="pi pi-verified mx-2" style="font-size: 1rem"></i>
            {{ "Approval update" | translator }}
          </button>
          <button
            *ngIf="hasPermission('SIGN_SERVICE', 'a')"
            (click)="confirmSignService(false)"
            icon="pi pi-verified"
            class="multi-btn btn-border-right btn-shadow"
            [disabled]="!selectionData || !selectionData.length"
          >
            <i class="pi pi-history mx-2" style="font-size: 1rem"></i>
            {{ "Unsign Data" | translator }}
          </button>
            <button
              *ngIf="hasPermission('SIGN_SERVICE_DURATION', 'a')"
              (click)="settingModel = true"
              icon="pi pi-spin pi-cog"
              class="multi-btn border-right btn-border-left btn-shadow"
            >
              <i class="pi pi-spin pi-cog" style="font-size: 1.5rem"></i>
            </button>
          </span>

          <!-- <button pButton pRipple label="Sign" (click)="confirmSignService()" icon="pi pi-verified"
                    class="p-button-help my-2 mx-2" [disabled]="!selectionData || !selectionData.length"></button>
                <button pButton pRipple  (click)="settingModel = true" icon="pi pi-spin pi-cog"
                class="p-button-help my-2 mx-2" ></button> -->
        </div>

        <div class="d-flex justify-content-center my-4">
          <div class="d-flex align-items-center gap-3">
            <div class="d-flex align-items-center">
              <p-radioButton
                name="pizza"
                [value]="true"
                (onClick)="selectionData = []; getData()"
                [(ngModel)]="activationFilter"
                inputId="activationFilterTrue"
              ></p-radioButton>
              <label for="activationFilterTrue" class="mx-2 v4-color-white">{{
                "active" | translator
              }}</label>
            </div>

            <div class="flex align-items-center">
              <p-radioButton
                name="pizza"
                [value]="false"
                (onClick)="selectionData = []; getData()"
                [(ngModel)]="activationFilter"
                inputId="activationFilterFalse"
              ></p-radioButton>
              <label for="activationFilterFalse" class="mx-2 v4-color-white">{{
                "Inactive" | translator
              }}</label>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="d-flex align-items-center gap-3">
            <div class="d-flex align-items-center">
              <p-radioButton
                name="pizza"
                [value]="'signed'"
                (onClick)="selectionData = []; getData()"
                [(ngModel)]="signFilter"
                inputId="signFilterTrue"
              ></p-radioButton>
              <label for="signFilterTrue" class="mx-2 v4-color-white">{{
                "Signed Data" | translator
              }}</label>
            </div>

            <div class="d-flex align-items-center">
              <p-radioButton
                name="pizza"
                [value]="'unsigned'"
                (onClick)="selectionData = []; getData()"
                [(ngModel)]="signFilter"
                inputId="signFilterFalse"
              ></p-radioButton>
              <label for="signFilterFalse" class="mx-2 v4-color-white">{{
                "Unsigned Data" | translator
              }}</label>
            </div>

            <div class="d-flex align-items-center">
              <p-radioButton
                name="pizza"
                [value]="'both'"
                (onClick)="selectionData = []; getData()"
                [(ngModel)]="signFilter"
                inputId="signFilterBoth"
              ></p-radioButton>
              <label for="activationFilterFalse" class="mx-2 v4-color-white">{{
                "Both Data" | translator
              }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!!states && !spinner" class="v4-data-flex">
    <div class="v4-w-20">
      <div class="d-flex flex-column">
        <h4 class="data-box-txt">{{'total' | translator}}
        </h4>
        <div class="v4-data-box">
          <span class="data-box-num">{{states[0]?.unknown ? states[0]?.unknown : 0}}</span>
        </div>
      </div>
    </div>

    <div class="v4-w-20">
      <div class="d-flex flex-column">
        <h4 class="data-box-txt">{{'Signed Data' | translator}}
        </h4>
        <div class="v4-data-box">
          <span class="data-box-num">{{states[0]?.signed ? states[0]?.signed : 0}}</span>
        </div>
      </div>
    </div>

    <div class="v4-w-20">
      <div class="d-flex flex-column">
        <h4 class="data-box-txt">{{'Unsigned Data' | translator}}
        </h4>
        <div class="v4-data-box">
          <span class="data-box-num">{{states[0]?.unsigned ? states[0]?.unsigned : 0}}</span>
        </div>
      </div>
    </div>

    <div class="v4-w-20">
      <div class="d-flex flex-column">
        <h4 class="data-box-txt">{{'active' | translator}}
        </h4>
        <div class="v4-data-box">
          <span class="data-box-num">{{states[0]?.active ? states[0]?.active : 0}}</span>
        </div>
      </div>
    </div>

    <div class="v4-w-20">
      <div class="d-flex flex-column">
        <h4 class="data-box-txt">{{'Inactive' | translator}}ة
        </h4>
        <div class="v4-data-box">
          <span class="data-box-num">{{states[0]?.inactive ? states[0]?.inactive : 0}}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- <app-skelitions [hidden]="!skelition2" [value]="10" class="mb-2"></app-skelitions> -->

  <p-messages [(value)]="messages" [enableService]="false"></p-messages>
  <div
    [hidden]="skelition2"
    *ngIf="!!selectionData && selectionData.length > 0"
  >

  

    <hr />
    <h1 class="v4-color-white">
      <i class="fa-solid fa-check-to-slot svg-icon-head"></i>
      {{ "Selected data" | translator }}
    </h1>
    <p-table
      [value]="selectionData"
      (onRowUnselect)="removeSelected($event)"
      (onHeaderCheckboxToggle)="unselectAllData()"
      [(selection)]="selectionCopy"
      dataKey="_id"
      [paginator]="true"
      [rows]="10"
      [selectionPageOnly]="true"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th style="min-width: 200px">
            <img
              class="svg-icon mx-1"
              src="../assets/icons/SBC/pages-multiple.svg"
              alt="loading"
            />{{ "Label" | translator }}
          </th>
          <th style="min-width: 200px">
            <img
              class="svg-icon mx-1"
              src="../assets/icons/Edit/24-dark@1.5x.svg"
              alt="loading"
            />{{ "Categories" | translator }}
          </th>
        </tr>
      </ng-template>
      <ng-template class="bg-color" pTemplate="body" let-product>
        <tr>
          <td>
            <p-tableCheckbox [value]="product"></p-tableCheckbox>
          </td>
          <td>
            <div>
              <img *ngIf="checkisImg(getGreatestDepthIcon(product)); else elseBlock" src="{{staticURL}}{{getGreatestDepthIcon(product)}}"
              class="img-fluid p-1 tree-img-bg" style="height: 30px; width: 30px; background: white; border-radius: 6px; margin-left: 5px;">
                <ng-template #elseBlock>
                    <i class="{{getGreatestDepthIcon(product)}} p-2" style="font-size: 1rem;"></i>
                </ng-template>
            </div>
            <strong
              style="line-height: 2rem"
              [innerHTML]="
                product.name && searchText
                  ? (product.name | highlight : searchText)
                  : (product.name | safeHTML)
              "
            ></strong>
          </td>
          <td class="d-flex">
            <div
              class="data-card"
              *ngFor="let field of sortFiled(product.fields)"
            >
              <span class="data-flex" style="line-height: 2rem">
                <span
                  class="data-heading my-1"
                  [innerHTML]="
                    field.label.name && searchText
                      ? (field.label.name | highlight : searchText)
                      : (field.label.name | safeHTML)
                  "
                ></span>
                <span
                  class="scroll"
                  [ngSwitch]="getFieldType(field?.field?.type)"
                >
                  <!-- For text -->
                  <div *ngSwitchCase="'text'">
                    <span
                      class="data-p my-1"
                      [innerHTML]="
                        field?.data && searchText
                          ? (field?.data | highlight : searchText)
                          : (field?.data | safeHTML)
                      "
                    ></span>
                  </div>
                  <!-- Rich text -->
                  <div *ngSwitchCase="'Rich text'">
                    <span
                      class="data-p my-1"
                      [innerHTML]="
                        field?.data && searchText
                          ? (field?.data | highlight : searchText)
                          : (field?.data | safeHTML)
                      "
                    ></span>
                  </div>
                  <div *ngSwitchCase="'Upload Image'">
                    <img
                      [hidden]="field?.data == ''"
                      class="img-fluid"
                      style="width: 100px"
                      [src]="GlobalConstants.staticFilesURL + field.data"
                    />
                  </div>
                  <div *ngSwitchCase="'Upload Document'">
                    <a
                      class="doc-view"
                      [hidden]="field?.data == ''"
                      target="_blank"
                      [href]="GlobalConstants.staticFilesURL + field.data"
                    >
                      <i
                        [hidden]="field?.data == ''"
                        class="pi pi-file mx-2"
                      ></i
                      >{{ "Add a file" | translator }}
                    </a>
                  </div>
                  <div *ngSwitchCase="'Data Item'">
                    <p class="data-p my-1">{{ field?.data?.name }}</p>
                  </div>
                </span>
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <hr />
  </div>
  <div class="d-flex justify-content-center align-items-center">
    <p-progressSpinner [hidden]="!spinner"></p-progressSpinner>
  </div>
  <div class="" *ngIf="filteredData.length > 0" [hidden]="spinner">
    <p-table
      [value]="filteredData"
      [(selection)]="selectionData"
      (onHeaderCheckboxToggle)="selectAllData()"
      (selectionChange)="getSelected($event)"
      dataKey="_id"
      [paginator]="true"
      [rows]="10"
      [selectionPageOnly]="true"
      [tableStyle]="{ 'min-width': '50rem' }"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th style="min-width: 200px">
            <img
              class="svg-icon mx-1"
              src="../assets/icons/SBC/pages-multiple.svg"
              alt="loading"
            />{{ "Label" | translator }}
          </th>
          <th style="min-width: 200px">
            <img
              class="svg-icon mx-1"
              src="../assets/icons/Edit/24-dark@1.5x.svg"
              alt="loading"
            />{{ "Categories" | translator }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <td>
            <p-tableCheckbox [value]="product"></p-tableCheckbox>
          </td>
          <td>
            <div>
              <img *ngIf="checkisImg(getGreatestDepthIcon(product)); else elseBlock" src="{{staticURL}}{{getGreatestDepthIcon(product)}}"
              class="img-fluid p-1 tree-img-bg" style="height: 30px; width: 30px; background: white; border-radius: 6px; margin-left: 5px;">
                <ng-template #elseBlock>
                    <i class="{{getGreatestDepthIcon(product)}} p-2" style="font-size: 1rem;"></i>
                </ng-template>
            </div>
            <strong
              style="line-height: 2rem"
              [innerHTML]="
                product.name && searchText
                  ? (product.name | highlight : searchText)
                  : product.name
              "
            ></strong>
          </td>
          <td class="d-flex">
            <div
              class="data-card"
              *ngFor="let field of sortFiled(product.fields)"
            >
              <span class="data-flex" style="line-height: 2rem">
                <div class="d-flex align-items-center">
                  <i class="{{ field.field.icon }}"></i>
                  <span
                    class="data-heading my-1 mx-2"
                    [innerHTML]="
                      field.label.name && searchText
                        ? (field.label.name | highlight : searchText)
                        : field.label.name
                    "
                  ></span>
                </div>
                <span
                  class="scroll"
                  [ngSwitch]="getFieldType(field?.field?.type)"
                >
                  <!-- For text -->
                  <div *ngSwitchCase="'text'">
                    <span
                      class="data-p my-1"
                      [innerHTML]="
                        field?.data && field?.data
                          ? (field?.data | highlight : field?.data)
                          : field?.data
                      "
                    ></span>
                  </div>
                  <!-- Rich text -->
                  <div *ngSwitchCase="'Rich text'">
                    <span
                      class="data-p my-1"
                      [innerHTML]="
                        field?.data && searchText
                          ? (field?.data | highlight : searchText)
                          : field?.data
                      "
                    ></span>
                  </div>
                  <div *ngSwitchCase="'Upload Image'">
                    <img
                      [hidden]="field?.data == ''"
                      class="img-fluid"
                      style="width: 100px"
                      [src]="GlobalConstants.staticFilesURL + field.data"
                    />
                  </div>
                  <div *ngSwitchCase="'Upload Document'">
                    <a
                      class="doc-view"
                      [hidden]="field?.data == ''"
                      target="_blank"
                      [href]="GlobalConstants.staticFilesURL + field?.data"
                    >
                      <i
                        [hidden]="field?.data == ''"
                        class="pi pi-file mx-2"
                      ></i>

                      {{ "Add file" | translator }}
                    </a>
                  </div>
                  <div *ngSwitchCase="'Data Item'">
                    <p class="data-p my-1" style="font-weight: 600">
                      {{ field?.data?.name }}
                    </p>
                  </div>
                </span>
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<app-no-data *ngIf="filteredData.length == 0 && !!selectionData && selectionData.length == 0 && !skelition && !spinner "></app-no-data>


<!-- Update Modal -->

<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="Header"
  [(visible)]="updateModal"
  [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1700px' }"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">
      {{ "Update content" | translator }}
    </span>
  </ng-template>
  <div class="row">
    <div
      *ngFor="let field of commonFields; let i = index"
      class="col-md-12 col-lg-6"
    >
      <div class="d-flex align-items-center">
        <p-checkbox
          [(ngModel)]="field.isChecked"
          class="shadow"
          [binary]="true"
          inputId="binary"
        ></p-checkbox>
        <label
          class="mx-2"
          style="font-weight: 600; margin-bottom: 0.3rem; color: white"
          >{{ field.label.name }}</label
        >
      </div>
      <div [ngSwitch]="getFieldType(field?.field?.type)">
        <!-- For text -->
        <div *ngSwitchCase="'text'">
          <span class="p-input-icon-right w-100">
            <i class="pi pi-clone"></i>
            <input
              pInputText
              [(ngModel)]="field.data"
              class="w-100"
              [id]="field.label"
              type="text"
            />
          </span>
        </div>
        <!-- Rich text -->
        <div *ngSwitchCase="'Rich text'">
          <p-editor
            [(ngModel)]="field.data"
            [id]="field.label"
            [style]="{ height: '320px' }"
          ></p-editor>
        </div>
        <div *ngSwitchCase="'Upload Image'">
          <img
            [hidden]="field.data == ''"
            class="img-fluid"
            style="width: 100px"
            [src]="GlobalConstants.staticFilesURL + field.data"
          />
          <p-fileUpload
            mode="basic"
            chooseLabel="Choose"
            name="file"
            [url]="apilink + 'file/data'"
            [auto]="true"
            chooseLabel="Browse"
            accept="image/*"
            [maxFileSize]="1000000"
            (onUpload)="field.data = $event.originalEvent.body.data"
          ></p-fileUpload>
        </div>
        <div *ngSwitchCase="'Upload Document'">
          <a
            class="doc-view"
            [hidden]="field.data == ''"
            target="_blank"
            [href]="GlobalConstants.staticFilesURL + field.data"
          >
            <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>
            {{ "Add file" | translator }}
          </a>
          <p-fileUpload
            mode="basic"
            chooseLabel="Choose"
            name="file"
            [url]="apilink + 'file/data'"
            [auto]="true"
            chooseLabel="Add File"
            [maxFileSize]="1000000"
            (onUpload)="field.data = $event.originalEvent.body.data"
          ></p-fileUpload>
        </div>
        <div *ngSwitchCase="'Data Item'">
          <button
            type="submit"
            (click)="toggleModal(i)"
            pButton
            pRipple
            label="Service {{ 'addition' | translator }}"
            icon="pi pi-fw pi-plus-circle"
            class="w-full my-3"
          ></button>
          <p-dialog
            [blockScroll]="true"
            [draggable]="false"
            header="Select Service"
            [maximizable]="true"
            [(visible)]="modalVisibilities[i]"
            [style]="{
              width: '95vw',
              maxWidth: '1700px',
              maxHeight: '900px',
              height: '85vh'
            }"
          >
            <div style="background-color: #f3f3f3 !important; padding: 15px">
              <app-select-service
                (currentDataItem)="changeCurrentDataItem($event, field, i)"
              ></app-select-service>
            </div>
          </p-dialog>
          <p class="font-bold" *ngIf="field.data">{{ field.data.name }}</p>
        </div>
        <div *ngSwitchDefault></div>
      </div>
    </div>

    <div class="col-md-12 col-lg-12 mt-2">
      <label
      class="mx-2"
      style="font-weight: 600; margin-bottom: 0.3rem; color: white"
      >{{ 'Reason' | translator }}</label>
      <p-editor
            [(ngModel)]="reasonHolder"
            [id]="'reason'"
            [style]="{ height: '320px' }"
          ></p-editor>
      <p *ngIf="reasonError" style="color: red">{{ 'Please Write a reason for update' | translator }}</p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every py-2" (click)="sendUpdateLogs()">
      <i class="pi pi-check v4-ml-2"></i>{{ "OK" | translator }}
    </button>
  </ng-template>
</p-dialog>

<!-- End Update Modal -->

<!-- Change OU Modal -->
<p-dialog
  [blockScroll]="true"
  header="Header"
  [(visible)]="updateOUModal"
  [maximizable]="true"
  [style]="{
    margin: '0rem 1rem',
    width: '95vw',
    maxWidth: '1700px',
    maxHeight: '600px'
  }"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{ "Update Data Ou" | translator }}</span>
  </ng-template>
  <div>
    <div class="d-flex justify-content-center py-3 bg-clr">
      <p-tree
        class="w-100 md:w-30rem"
        [filter]="true"
        selectionMode="single"
        [(selection)]="assignOU"
        filterPlaceholder="{{ 'search' | translator }}"
        [value]="selectedTreeData"
        [draggableNodes]="true"
        [droppableNodes]="true"
        draggableScope="self"
        droppableScope="self"
      >
        <ng-template let-node pTemplate="default">
          <div class="d-flex">
            <img
              *ngIf="checkisImg(node.data); else elseBlock"
              src="{{ staticURL }}{{ node.data }}"
              class="img-fluid p-1"
              style="
                height: 30px;
                width: 30px;
                background: white;
                border-radius: 6px;
                margin-left: 5px;
              "
            />
            <ng-template #elseBlock>
              <i class="{{ node.data }} p-2" style="font-size: 1rem"></i>
            </ng-template>
            <b class="text-nowrap">{{ node.label }}</b>
          </div>
        </ng-template>
      </p-tree>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every py-2" (click)="updateDataOU()">
      <i class="pi pi-check v4-ml-2"></i>{{ "OK" | translator }}
    </button>
  </ng-template>
</p-dialog>
<!-- End OU Modal -->

<!-- Change OU Modal -->
<p-dialog
  [blockScroll]="true"
  header="Header"
  [(visible)]="settingModel"
  [maximizable]="true"
  [style]="{
    margin: '0rem 1rem',
    width: '95vw',
    maxWidth: '550px',
    maxHeight: '600px'
  }"
>
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">
      {{ "Settings" | translator }}
    </span>
  </ng-template>
  <div>
    <div
      *ngIf="this.settings"
      class="d-flex justify-content-center align-items-baseline flex-wrap py-3 bg-clr"
    >
      <p class="color-bold mx-2 text-white">
        {{ "Validity" | translator }}
      </p>
      <div>
        <input
          dir="ltr"
          type="number"
          class="radius-8 mt-2"
          pInputText
          placeholder="duration"
          [(ngModel)]="this.settings.sign_duration"
        />
      </div>
      <p class="color-bold mx-2 text-white">({{ "Months" | translator }})</p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button class="v4-btn-every py-2" (click)="upDateSetting()">
      <i class="pi pi-check v4-ml-2"></i>{{ "OK" | translator }}
    </button>
  </ng-template>
</p-dialog>
<!-- End OU Modal -->

<!-- Update Reason modal -->
<div class="card flex justify-content-center">
  <p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'the reason' | translator }}"
    [(visible)]="reasonModal" [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '600px' }"
    [maximizable]="true">
    <div class="w-100">
      <p>{{ "the reason" | translator }}</p>
      <p-editor [(ngModel)]="reasonHolder" [style]="{ height: '320px' }">
      </p-editor>
      <p *ngIf="reasonError" style="color: red">{{ 'Please Write a reason for update' | translator }}</p>
    </div>
    <ng-template pTemplate="footer">
      <button class="v4-btn-every py-2" (click)="confirmDeleteService()" 
        ><i class="pi pi-check v4-ml-2"></i>{{ 'OK' | translator }}</button>
    </ng-template>
  </p-dialog>
</div>

<app-footer></app-footer>

<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="Data"
  [(visible)]="fieldModal"
  [style]="{ margin: '0rem 1rem' }"
  [maximizable]="true"
>
  <span [innerHTML]="fieldData | safeHTML"></span>
</p-dialog>

<p-toast></p-toast>
